import styled from 'styled-components';
import { Card } from 'src/components';

export const Wrapper = styled.div`
  background: rgb(121 174 192);
  min-height: 0;
  height: auto;
  flex: 1;
  padding-bottom: 24px;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (min-width: 992px) {
    min-height: calc(100dvh - 120px);
  }
`;

export const Header = styled(Card)`
  border-radius: 10px;
`;

export const Board = styled.div`
  display: flex;
  align-items: flex-start;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 8px;

  @media (min-width: 992px) {
    height: calc(100dvh - 220px);
    min-height: 320px;
    overflow-x: auto;
    overflow-y: hidden;
  }

  @media (max-width: 991px) {
    height: auto;
    min-height: 0;
    overflow-x: auto;
    overflow-y: visible;
  }

  ::-webkit-scrollbar {
    background: #dfe3e6;
    border-radius: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #6b808c;
    border-radius: 10px;
  }
`;

export const AddListWrapper = styled.div`
  width: 272px;
  max-width: min(272px, 85vw);
  margin: 10px;
  flex-shrink: 0;
`;

export const AddListButton = styled.div`
  background-color: rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 5px 8px;
  transition: background-color 85ms ease-in, opacity 40ms ease-in,
    border-color 85ms ease-in;
  height: fit-content;

  &:hover {
    background-color: rgba(0, 0, 0, 0.24);
  }

  svg {
    margin-right: 1px;
  }
`;
